import { render } from "./PublicPerson.vue?vue&type=template&id=5bb3143b&scoped=true"
import script from "./PublicPerson.vue?vue&type=script&lang=js"
export * from "./PublicPerson.vue?vue&type=script&lang=js"

import "./PublicPerson.vue?vue&type=style&index=0&id=5bb3143b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb3143b"]])

export default __exports__